'use strict';

import tooltip from '../tooltip';
import util from '../util';
import dialog from '../dialog';
import page from '../page';
import login from '../login';
import modalExport from '../modal';
const modal = modalExport.global;
import cardValidation from './checkout/card-validation';
import orderReturn from './orderReturn';
import orderHistory from './orderHistory';
import orderCancel from './orderCancel';
import validator from '../validator';
import search from './search';
import processstates from './processstates';
import progress from '../progress';
import recaptcha from '../recaptcha';
import checkoutAddress from './checkout/address';
import googleAddressAutocomplete from './checkout/googleAddressAutocomplete';
import adyenCheckout from '../adyen/adyen-checkout';
import inputField from '../input-field';

let session_ShowCaptcha = SessionAttributes.SHOW_CAPTCHA;

/**
 * @function
 * @description Initializes the events on the address form (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm() {
    var $form = $('#edit-address-form');       	
    processstates.refreshStates($form);

    $form.find('input[name="format"]').remove();
    tooltip.init();
    //$("<input/>").attr({type:"hidden", name:"format", value:"ajax"}).appendTo(form);

    $form.on('click', '.apply-button', function (e) {
        /****
        * e.preventDefault();
        * if (!$form.valid()) {
        *     return false;
        * }
        * var url = util.appendParamToURL($form.attr('action'), 'format', 'ajax');
        * var applyName = $form.find('.apply-button').attr('name');
        * var options = {
        *     url: url,
        *     data: $form.serialize() + '&' + applyName + '=x',
        *     type: 'POST'
        * };
        * $.ajax(options).done(function (data) {
        *     if (typeof(data) !== 'string') {
        *         if (data.success) {
        *             dialog.close();
        *             page.refresh();
        *         } else if (data.error) {
        *             page.redirect(Urls.csrffailed);
        *         } else {
        *             window.alert(data.message);
        *             return false;
        *         }
        *     } else {
        *         $('#dialog-container').html(data);
        *         account.init();
        *         tooltip.init();
        *     }
        * });
        ****/
    })
    .on('click', '.cancel-button, .close-button', function (e) {
        e.preventDefault();
        dialog.close();
    })
    .on('click', '.delete-button', function (e) {
        e.preventDefault();
        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            var url = util.appendParamsToUrl(Urls.deleteAddress, {
                AddressID: $form.find('#addressid').val(),
                format: 'ajax'
            });
            $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    dialog.close();
                    page.refresh();
                } else if (data.message.length > 0) {
                    window.alert(data.message);
                    return false;
                } else {
                    dialog.close();
                    page.refresh();
                }
            });
        }
    });
}
/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder () {
    $('.order-items')
        .find('li.hidden:first')
        .prev('li')
        .append('<a class="toggle">View All</a>')
        .children('.toggle')
        .click(function () {
            $(this).parent().siblings('li.hidden').show();
            $(this).remove();
        });
}
/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
    var addresses = $('#addresses');
    if (addresses.length === 0) { return; }

    addresses.on('click', '.address-edit, .address-create', function (e) {
        e.preventDefault();
        dialog.open({
            url: this.href,
            options: {
                open: initializeAddressForm
            }
        });
        setTimeout(() => {
            util.limitCharacters();
        }, 2500);
    }).on('click', '.delete', function (e) {
        e.preventDefault();
        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            $.ajax({
                url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax'),
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    page.redirect(Urls.addressesList);
                } else if (data.message.length > 0) {
                    window.alert(data.message);
                } else {
                    page.refresh();
                }
            });
        }
    });
}
/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
    $('.add-card').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                open: initializePaymentForm
            }
        });
    });

    $(document).on("click", ".credit-card-create", function (evt) {
        modal.events.onOpen(function () {
            creditCardTypeDetector();
            validator.initForm('form[id$="CreditCardForm"]');
        });
        modal.addCustomClass('medium add-credit-card')
        modal.renderByUrl(Urls.myaccountAddCreditCard);
        modal.setCallback(cardValidation.init);
        initAdyenComponent();
    });
    
    // Edit
    
    $(document).on("click", ".credit-card-edit", function (evt) {
    	evt.preventDefault();
        var creditcardtoken = $(this).data('creditcardtoken');
        var url = Urls.checkoutEditCreditCard + creditcardtoken;

        modal.restoreDefaultClass();
        modal.events.onOpen(function () {
            $('.cc-number input').prop('disabled', true);
            validator.initForm('form[id$="CreditCardForm"]');
        });
        modal.addCustomClass('small edit-credit-card');
        modal.renderByUrl(url);
        initAdyenComponent();
    });

    function initAdyenComponent() {
        // Modal rendered first and after that Adyen form component load - Unable to check with promise's here
        setTimeout(() => {
            if (SitePreferences.ADYEN_SF_ENABLED) {
                adyenCheckout.initAccount();
                $('.input-checkbox.setasdefault').val(false);
                $('.input-checkbox.setasdefault').change(function () {
                    if (this.checked) {
                        $('.input-checkbox.setasdefault').val(true);
                    }
                });
            }
        }, 2500);
    };

    $('form.remove-card-form button.delete').on('click', function (e) {
    	e.preventDefault();
    	var $button = $(this);
    	var $form = $button.closest('form.remove-card-form');
    	var popup = new Foundation.Reveal($('#remove-card'));
    	popup.open();

    	//Yes button
    	$( ".cardDelete-modal-btn-ok" ).unbind();
    	$( ".cardDelete-modal-btn-ok" ).click(function() {
    		popup.close();

    		$('<input/>').attr({
				type: 'hidden',
				name: $button.attr('name'),
				value: $button.attr('value') || 'delete card'
			}).appendTo($form);
			var data = $form.serialize();
            progress.show($('#main'));
			$.ajax({
				type: 'POST',
				url: $form.attr('action'),
				data: data
			})
			.done(function () {
                progress.hide();
				page.redirect(Urls.paymentsList);
			});
    	});

    	//No button
    	$( ".cardDelete-modal-btn-cancel" ).unbind();
		$( ".cardDelete-modal-btn-cancel" ).click(function() {
    		popup.close();
    	});
    });

}

function initializePaymentForm() {
    $('#CreditCardForm').on('click', '.cancel-button', function (e) {
        e.preventDefault();
        dialog.close();
    });
    initAdyenComponent();
}

function mobileAccountMenu() {
    var pageContainer = $('#main');
    var primaryContent = $('#primary');
    var primaryContentHeight = $('#primary').outerHeight();
    var mobileNav = $('#secondary');
    var accountText = $('.account-text');
    var currentUrl = window.location.href;
    var cleanUrl = currentUrl.split('?')[0];

    $('.account-nav-asset a[href="'+ cleanUrl +'"]').addClass('active-menu');

    $('.account-nav-asset a').on('click', function(e) {
        e.preventDefault();
        var url = $(this).attr('href');

        if (url != cleanUrl) {
            var target = $(this).attr('target');
            if(target != null && target == "_blank") {
                window.open(url);
            } else {
                window.location = url;
            }
        } else {
            mobileNav.css('min-height', primaryContentHeight);
            pageContainer.addClass('content-show');
        }
    });

    $('.back-to-account-btn a').on('click', function(e) {
        e.preventDefault();
        pageContainer.removeClass('content-show');
        mobileNav.css('min-height', 0);

    });
}



function registerAccountEvents(){
    // get the field elements
    var $gender = $('.registration-box #dwfrm_profile_customer_gender');
    var $newsletterCB = $('.registration-box #dwfrm_profile_customer_addtoemaillist');

    $gender.on('change', function(e){
        $(this).closest('form').find('button[type="submit"]').prop('disabled', false);
    });
    $newsletterCB.on('change', function(e){
        $(this).closest('form').find('button[type="submit"]').prop('disabled', false);
    });
    if(window.User.isExternallyAuthenticated=='Social') {
        if($('#dwfrm_profile_customer_firstname').val()=='') {
            $('#dwfrm_profile_customer_firstname').blur();
        }
        if($('#dwfrm_profile_customer_lastname').val()=='') {
            $('#dwfrm_profile_customer_lastname').blur();
        }
    }
}

function addressEvents() {
    function toggleBillingAddressFields(visible) {
        if (visible == true) {
            $('.country-dependent').each(function() {
                $(this).show();
            });
        } else {
            $('.country-dependent').each(function() {
                $(this).hide();
            });
        }

        if (window.User.isCustomerAuthenticated == false) {
        	$('.checkout-billing').find('.set-default-cb').hide();
        }
    }

    $(document).on('change', '#dwfrm_billing_billingAddress_addressFields_country', function() {
        var currentElement = $(this);
        var selectContry = $(currentElement).val();
        var $form = $(currentElement).closest('form');
        //populate the tooltip for different markets
        if(selectContry !== undefined && selectContry !== ''){
            var $selectContry = selectContry.toLowerCase();
            var postalTooltip = currentElement.data('postalcodetooltipjson')[$selectContry];
            $form.find('.postal-code .tooltip .tooltip-content').html(postalTooltip);
            tooltip.init();
        }
        
        if (selectContry == '') {
            toggleBillingAddressFields(true);
        } else if (selectContry == 'us' || selectContry == 'ca'){
            toggleBillingAddressFields(true);
            $(".us-fields").show();
            $(".cn-fields").hide();
            $form.find('.postcode').removeClass('required');
            $form.find('.province').removeClass('required');
        } else {
            toggleBillingAddressFields(true);
            
            //pre-populate the Country Calling Code for phone field
            util.prePopulateCallingCountryCode($(this).val());
            util.handleCountryCodeUpdate($form.find('input[name$="_phone"]'));
            
            $(".cn-fields").show().css({"display" : "flex"});
            if($(".postcode").length) {
                $form.find('.postcode').addClass('required').rules('add', {
                    required: true,
                    postal: true,
                    messages: {
                        postal: Resources.INVALID_POSTAL
                    }
                });
            }
            if($(".province").length) {
                $form.find('.province').addClass('required').rules('add', {
                    required: true,
                    simpletext: true,
                    messages: {
                        simpletext: Resources.VALIDATE_PROVINCE
                    }
                });
            }
        }
    });

    $(document).on("click", ".address-create", function (evt) {
        modal.setCallback(function() {
            toggleBillingAddressFields(true);
        });

        toggleBillingAddressFields(true);

        modal.addCustomClass('edit-add-address new-add-address');
        modal.events.onOpen(function() {
        	validator.initForm('form[id="EditAddressForm"]');
        	tooltip.init();
            checkoutAddress.init();
            googleAddressAutocomplete.init();
        });

        modal.renderByUrl(Urls.checkoutAddAccountAddress);
        util.phoneAccountAddressModal();
        util.postalAccountAddressModal();
        setTimeout(() => {
            util.limitCharacters();
        }, 2500);
   });

   $(document).on("click", ".address-edit", function (evt) {
       var element = document.getElementById(evt.currentTarget.id);
       var addressID = element.dataset.addressId;
       var addressCode = element.dataset.addressCode;
       var url = Urls.checkoutEditAccountAddress + addressID;

       modal.setCallback(function() {
        if (addressCode == 'us' || addressCode == 'ca') {
               toggleBillingAddressFields(true);
               $(".us-fields").show();
               $(".cn-fields").hide();
               enableCountryField(false);
           } else if (addressCode == 'cn') {
            toggleBillingAddressFields(true);
               $(".cn-fields").show().css({"display" : "flex"});
               $(".us-fields").hide();
               enableCountryField(false);
           } else {
               toggleBillingAddressFields(true);
               enableCountryField(true);
           }

	    	var $form = $('form[id$="EditAddressForm"]');
	    	var $savedCountry = $form.find('select[name$="_country"]').val();
	    	$savedCountry = $savedCountry.toLowerCase();
	    	var postalTooltip= $('select[name$="_country"]').data('postalcodetooltipjson')[$savedCountry];
	    	$form.find('.postal-code .tooltip .tooltip-content').html(postalTooltip);
            $('select[id$="_country"]').trigger('change');

       });
       modal.events.onOpen(function() {
    	   validator.initForm('form[id$="EditAddressForm"]');
    	   var $form = $('form[id$="EditAddressForm"]');            	
    	   processstates.refreshStates($form);
    	   var savedCountry = $('#dwfrm_billing_billingAddress_addressFields_country').attr('data-country');
    	   $('select[name$="_country"]').val(savedCountry);
    	   var countryCode = util.getCallingCountryCode(savedCountry);
    	   var phoneFiled =  $form.find('input[name$="_phone"]');
    	   phoneFiled.attr('data-country-code', countryCode);
    	   util.handleCountryCodeUpdate(phoneFiled);
    	   tooltip.init();
           checkoutAddress.init();
           googleAddressAutocomplete.init();
           inputField.setEditMaterialFields();
       });
       modal.addCustomClass('edit-add-address');
       modal.renderByUrl(url);   
       inputField.setEditMaterialFields();	
       setTimeout(() => {
        util.limitCharacters();
    }, 2500);
       });

   $(document).on('click', '.address-delete', function (e) {
       e.preventDefault();
       var href = $(this).attr('href');
       var popup = new Foundation.Reveal($('#remove-address'));
       popup.open();
       //Yes button
       $( ".addressDelete-modal-btn-ok" ).click(function() {
    	   $.ajax({
               url: util.appendParamToURL(href, 'format', 'ajax'),
               dataType: 'json'
           }).done(function (data) {
               page.refresh();
           });
       });
       //No button
       $( ".addressDelete-modal-btn-cancel" ).click(function() {
           popup.close();
       });

   });
}

function enableCountryField(status) {
	var countryField = $('select[id$="billing_billingAddress_addressFields_country"]');
	if (status) {
		countryField.removeAttr('disabled');
	} else {
		countryField.prop('disabled', true);
	}
}

function initContactUs() {
	$('.send-contact-us button').on('click', function(e) {
		e.stopPropagation();
		var messageText = $('.contact-comment textarea').val();
		$('.contact-comment textarea').focus();
		if(messageText == "") {
			$('.contact-comment textarea').siblings('span.error').remove();
			$('<span class="error">' + $('.contact-comment textarea').attr('data-required-text') + '</span>').insertBefore($('.contact-comment textarea'));
			$('.contact-comment textarea').addClass('error');
		}
	});
	
	var isformSubmitted = false;

	$('form.contact-us-form .contactus-submit').on('click', function(e) { 
		if (!$('form.contact-us-form').valid()) {
			return false;
		}
		
    	if(SitePreferences.Recaptcha_isEnabled && session_ShowCaptcha && !grecaptcha.getResponse()){
    		$('div.contactus_recaptcha_verification_error').html(Resources.VALIDATE_CAPTCHA);	
    		return;
    	}
    	
    	$('#contactusphone').val($('input[name$="_phone"]').val());
       
    	if($('.contact-comment textarea').val() !== "") {
    		if (!isformSubmitted && recaptcha.getGoogleRecaptchaEnableStatus(recaptcha.source.CONTACT_US)) {
               
                try{
                    $('form.contact-us-form .contactus-submit').attr("disabled", true);
    			recaptcha.generateRecaptchaToken(e, recaptcha.source.CONTACT_US, function (token) {
    				var submitURL = util.appendParamToURL(Urls.customerServiceSubmit, 'captchaToken', token);
    				$.ajax({
    					url: util.appendParamToURL(submitURL, 'format', 'ajax'),
    					data: $('form#ContactUsForm').serialize(),
    					method: 'POST',
    					aync: false
    				})
    				.done(function (response) {
    					if (response.status) {

                            $("<input>").attr({ 
                                name: "orgid", 
                                type: "hidden", 
                                value: response.orgid 
                            }).appendTo("form#ContactUsForm"); 
    
                            $("<input>").attr({ 
                                name: "retURL", 
                                type: "hidden", 
                                value: response.returnUrl  
                            }).appendTo("form#ContactUsForm");
    
                            $('form#ContactUsForm').attr('action', response.targetUrl);
                            isformSubmitted = true;

                            $(document).trigger('contactusformsubmission');
                            
                            $('form#ContactUsForm').trigger('submit');       
    						return true;
    					} else {
    						recaptcha.displayRecaptchaError(response.errorMsg);
                            $('form.contact-us-form .contactus-submit').removeAttr("disabled");
    						return false;						
    					}
    				});
    			});
                }catch(err) {
                    console.error('Recaptcha Error - '+err.message);
                    isformSubmitted = false
                    $('form.contact-us-form .contactus-submit').removeAttr("disabled");
                    return false;	
                }
                
    		} else {
    			isformSubmitted = false
    		}
    	}
	});
    $('.myquestion-select select').on('change', onConcernChange);
    
    $(".suggestion-question").on("click", function() {
		const $this = $(this);
		const $answer = $this.next(".suggestion-answer");

		if ($this.hasClass("active")) {
			$this.removeClass("active");
			$answer.slideUp(800);
		} else {
			$(".suggestion-question").removeClass("active");
			$(".suggestion-answer").slideUp();

			$this.addClass("active");
			$answer.slideDown(800);
		}
	});

    // pre-populate country code in phone field
    var countryCode = $('input[name$="_addressFields_country"]').val();
    util.prePopulateCallingCountryCode(countryCode);

    $('form.contact-us-form select[id$="_country"]').on('change', function(e) {
        var countryCode = $(this).val();
        util.prePopulateCallingCountryCode(countryCode);
    });
}

function onConcernChange() {
    const key = $(this).find("option:selected").data("key");
	if($(this).val() == 'Order tracking / delivery' || $(this).val() == 'Invoice request') {
		$('.order-number-input').show();
		$('.order-number-input').find('input').addClass('required');
	}else{
		removeOrderNumberInput();
	}

    if (!key) {
        $(".suggestions:visible").slideUp(500);
        return;
    }
    const $target = $(`.suggestions[data-key="${key}"]`);

    $(".suggestions:visible").not($target).slideUp(500);

    if (!$target.is(":visible")) {
        $target.slideDown(500);
    }
}

function removeOrderNumberInput() {
	$('.order-number-input').hide();
	$('.order-number-input').find('input').removeClass('required');
}

/**
 * Clear contact us form
 */
function clearContactUsForm() {
	$('input').val('');
	$('textarea').val('');
	$('.char-remain-count').text(500);
	
	removeOrderNumberInput();
}

function enableDisableSubmitButton(el){
    var $saveBtn = $(el).closest('form').find('button[type="submit"]');

    var hasError = $saveBtn.closest('form').find('span.error');
    if(hasError.length){
//        $saveBtn.prop('disabled', true);
    } else {
        $saveBtn.prop('disabled', false);
    }
}

function setGender () {
    var gender = $('.gender select').data('gender');

    $('.gender select').val(gender);
}

function getBirthday (birthmonth, dob, birthyear) {
    var birthday = [
        birthmonth,
        '/',
        dob,
        '/',
        birthyear
    ].join('');

    if (birthday === '00/00/' || birthday === '0/0/') {
        birthday = '';

        $('.birthdate .birthmonth select').val('00');
        $('.birthdate .dob select').val('00');
    }

    $('.birthday input').val(birthday);
}

function setBirthday () {
    var birthmonth = ('0' + $('.birthdate .birthmonth select').data('birthmonth')).slice(-2) || Number('00');
    var dob = ('0' + $('.birthdate .dob select').data('dob')).slice(-2) || Number('00');
    var birthyear = $('.birthdate .birthyear input').data('birthyear');

    $('.birthdate .birthmonth select').val(birthmonth);
    $('.birthdate .dob select').val(dob);
    $('.birthdate .birthyear input').val(birthyear);

    getBirthday(birthmonth, dob, birthyear);
}

function setNewBirthday (birthmonth, dob, birthyear) {
    var monthField = $('.birthdate .birthmonth select');
    var dayField = $('.birthdate .dob select');
    var yearField = $('.birthdate .birthyear input');

    var month = ~~birthmonth ? birthmonth : '';
    var day = ~~dob ? dob : '';
    var year = ~~birthyear ? birthyear : '';

    monthField.siblings('.error').remove();
    monthField.removeClass('-error-pad');
    dayField.removeClass('-error-pad');
    yearField.removeClass('-error-pad');

    if(month || day || year) {
        var now = new Date();
        var birthday = new Date(birthyear, birthmonth - 1, dob, 0, 0, 0, 0);

        if(!month.match(/^[\d]{1,2}$/)
            || !day.match(/^[\d]{1,2}$/)
            || !year.match(/^[\d]{4}$/)
            || !birthday.getTime()
            || now.getTime() <= birthday.getTime()){

            $('<span class="error">'+ Resources.INVALID_BIRTHDAY +'</span>').insertBefore(monthField);
            monthField.addClass('-error-pad');
            dayField.addClass('-error-pad');
            yearField.addClass('-error-pad');
        }
    }

    getBirthday(birthmonth, dob, birthyear);

    var hasError = $('#profile-save-changes').closest('form').find('span.error');

    if(hasError.length){
//        $('#profile-save-changes').prop('disabled', true);
    } else {
        $('#profile-save-changes').prop('disabled', false);
    }
}

function updateBirthday () {
    var birthday = $('.birthday input').val();
    var birthmonth = $('.birthdate .birthmonth select').val();
    var dob = $('.birthdate .dob select').val();
    var birthyear = $('.birthdate .birthyear input').val();

    $('.birthdate .birthmonth select').change(function () {
        birthmonth = $(this).val();

        if (birthyear || (birthmonth === '00' && !birthyear)) {
            setNewBirthday(birthmonth, dob, birthyear);
        }
    });

    $('.birthdate .dob select').change(function () {
        dob = $(this).val();

        if (birthyear || (dob === '00' && !birthyear)) {
            setNewBirthday(birthmonth, dob, birthyear);
        }
    });

    $('.birthdate .birthyear input').blur(function () {
        birthyear = $(this).val();

        setNewBirthday(birthmonth, dob, birthyear);
    })
}

function creditCardTypeDetector(options) {

    // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
    // Visa
    var visa_regex = new RegExp('^4[0-9]{0,15}$'),

        // MasterCard
        mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),

        // American Express
        amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),

        //Discover
        discover_regex = new RegExp('^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$'),

        //JCB
        unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

    $('.cc-number input').focusout(function (e) {
        var cur_val = $(this).val();

        //Commenting this out since the event is handled on focusout
        // if ( cur_val.length == 16 ) {
        //     e.preventDefault();
        //     return;
        // }

        var $ccNumberContain = $(this).parents('.cc-number');

        // get rid of spaces and dashes before using the regular expression
        cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

        var $creditCard = $('[data-method="CREDIT_CARD"]');

        // checks per each, as their could be multiple hits
        if (cur_val.match(visa_regex)) {
            $ccNumberContain.addClass('is_visa');
            $creditCard.find('input[name$="_type"]').val("Visa").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_visa');
        }

        if (cur_val.match(mastercard_regex)) {
            $ccNumberContain.addClass('is_mastercard');
            $creditCard.find('input[name$="_type"]').val("MasterCard").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_mastercard');
        }

        if (cur_val.match(amex_regex)) {
            $ccNumberContain.addClass('is_amex');
            $creditCard.find('input[name$="_type"]').val("Amex").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_amex');
        }

        if (cur_val.match(discover_regex)) {
            $ccNumberContain.addClass('is_discover');
            $creditCard.find('input[name$="_type"]').val("Discover").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_discover');
        }

        if (cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_unionpay');
            $creditCard.find('input[name$="_type"]').val("Union").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_unionpay');
        }

        // if nothing is a hit we add a class to fade them all out
        if (cur_val != '' && !cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) &&
            !cur_val.match(amex_regex) && !cur_val.match(discover_regex) && !cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_nothing');
        } else {
            $ccNumberContain.removeClass('is_nothing');
        }
    });

};

var checkContactSpam = function () {
    $('#validation-checkbox').change(function () {
        if($(this).prop('checked') == true){
            $('#sendBtn').prop("disabled", true);
        }        
    });
};


// modal to show message "contact to customer services"
// when order shipped more than 1 year(s) and user clicks on download invoice
var downloadInvoice = function() {
    $('.download-invoice-modal').on('click', function(e) {
        e.preventDefault();
        $.ajax({
            url: util.appendParamToURL(Urls.downloadInvoice, 'format', 'ajax'),
            method: 'GET'
        })
        .done(function (response) {
            if (response.message) {
                modal.addCustomClass('download-invoice-modal');
                modal.renderContent(response.message);
            }
        });
    });
    
    $('.download-invoice-from-sfsc').on('click', function(e) {
        e.preventDefault();
        progress.show($('#main'));
        $.ajax({
			url: util.appendParamToURL(Urls.downloadInvoiceFromSFSC, 'order_id', $('#order_id').val()),
			method: 'GET'
		})
		.done(function (response) {
			if(response.success) {
				downloadPDF(response.data, $('#order_id').val());
			}else {
				 modal.addCustomClass('download-invoice-from-sfsc');
	             modal.renderContent(response.data);
			}
			progress.hide();
		});
       
    });
}

function downloadPDF(pdf,orderID) {
	base64toPDF(pdf, orderID);
}

function base64toPDF(data, orderID) {
    var bufferArray = base64ToArrayBuffer(data);
    var blobStore = new Blob([bufferArray], { type: "application/pdf" });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);
        return;
    }
    var data = window.URL.createObjectURL(blobStore);
    var link = document.createElement('a');
	var fileName = orderID +".pdf";
    document.body.appendChild(link);
	link.setAttribute('href', data);
	link.setAttribute('download', fileName);
    link.click();
    window.URL.revokeObjectURL(data);
	document.body.removeChild(link);
}

function base64ToArrayBuffer(data) {
    var bString = window.atob(data);
    var bLength = bString.length;
    var bytes = new Uint8Array(bLength);
    for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
};

/**
 * combine country code with phone number
 */
function getPhoneNumWithCode() {
	if($('#dwfrm_singleshipping_shippingAddress_addressFields_phoneNumber').length === 0) {
		return; 
	}
	$(document).on('focusout','.contact-us-form input[class~="phonenumber"]', function() {
        var customPhoneNumber = $('#dwfrm_singleshipping_shippingAddress_addressFields_phoneNumber').val();
        var selectedCountryCode = $('#dwfrm_singleshipping_shippingAddress_addressFields_country').val();
        if(customPhoneNumber != 'null' && selectedCountryCode != 'null'){
            var formattedPhoneNumber = util.getFormattedPhoneNumber(customPhoneNumber,selectedCountryCode);
            $('#dwfrm_singleshipping_shippingAddress_addressFields_phone').val(formattedPhoneNumber);		
            $('#contactusphone').val(formattedPhoneNumber);	
        }
    });
}


/**
 * @private
 * @function
 * @description Checks if first name and last name are empty, and if so, disable
 * all elements in the page, if not, enables all the elements
 */
function checkEmptyInput() {

    const firstName = $('#RegistrationForm input.firstname');
    const lastName = $('#RegistrationForm input.lastname');

    if ($('.pt_account').length > 0 && firstName.val() == '' && lastName.val() == '') {
        const elementRestricted = $('#minimized-header-container, .breadcrumb, #secondary, .footer-container, .carousel-recommendations, #ChangeUsername button, #ChangePasswordForm button, .user-info button, #ChangePasswordForm button');

        const disableElements = () => {
            $('#RegistrationForm button').trigger('click');
            elementRestricted.prop('disabled', true).css('pointer-events', 'none');
        }

        $(() => {
            // If first name and last name are empty, disable all the elements
            setTimeout(() => {
                disableElements();
            }, 1000);
            

            // Enable the elements if First name has a value
            firstName.on('input change', () => {
                $('#RegistrationForm button').prop("disabled", (firstName.val() && lastName.val()) ? false : true);
                $('#RegistrationForm button').css('pointer-events', '');
            });

            // Enable the elements if last name has a value
            lastName.on('input change', () => {
                $('#RegistrationForm button').prop("disabled", (firstName.val() && lastName.val()) ? false : true);
                $('#RegistrationForm button').css('pointer-events', '');
            });
        });
    }
}




/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
    cardValidation.init();
    toggleFullOrder();
    //initAddressEvents();
    initPaymentEvents();
    login.init();
    registerAccountEvents();
    addressEvents();
    initContactUs();
    mobileAccountMenu();
    setGender();
    setBirthday();
    updateBirthday();
    search.viewMore();
    processstates.init();
    orderReturn.init();
    orderHistory.init();
    orderCancel.init();
    checkContactSpam();
    checkoutAddress.init();
    downloadInvoice();
    getPhoneNumWithCode();
    checkEmptyInput();
}


var account = {
    init: function () {
        initializeEvents();
        util.characterLimitEvents();
    },
    initCartLogin: function () {
        login.init();
    },
    initMobileMenu: function () {
        mobileAccountMenu();
    }
    
};

export default account;
